import React, {useState, useEffect} from 'react';
import Time from '../../Time';
import '../../css/App.css'
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap'

class ReportToPrint extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {

    let reportHTML;
    if(this.props.reportList.length > 0){ reportHTML = this.props.reportList.map((row, index) =>
      <tr key={index}>
        <td>{row.name}</td>
        <td>{row.hours.toFixed(2)}</td>
        <td>{row.vacation.toFixed(2)}</td>
        <td>{row.holiday.toFixed(2)}</td>
      </tr>
      )
    }

    return(
        <div className='p-4'>
            <h3>Generated by: {this.props.user}</h3>
            <h5>Payroll Report Generated at: {this.props.generatedDate}</h5>
            <p>Start date: {this.props.startDate}</p>
            <p>End date: {this.props.endDate}</p>
          <table className="table">
            <thead>
                <tr>
                  <th>Name</th>
                  <th>Payroll Hours for Period</th>
                  <th>Vacation Hours for Period	</th>
                  <th>Stat Holiday Hours</th>
                </tr>
            </thead>
            <tbody>
              {reportHTML}
            </tbody>
          </table>
        </div>
    );
  }
}

export default ReportToPrint;